import Link from 'next/link'

import { Button } from '@wartek-id/button'

const url = '/pelatihan-mandiri/daftar-topik'

const TopicMore = () => {
  return (
    <div>
      <div className="text-lg font-semibold">
        Tidak menemukan topik yang Anda cari?
      </div>
      <div className="my-2 text-sm text-gray-60">
        Cobalah temukan di halaman daftar topik
      </div>
      <Link href={url} passHref>
        <Button color="black" fullWidth>
          Lihat daftar topik
        </Button>
      </Link>
    </div>
  )
}

export default TopicMore
